import { mockConsultationDB } from './mockDb';
import type { Order, OrderFormData } from '../types';

export const orderService = {
  async getAll(): Promise<Order[]> {
    await new Promise(resolve => setTimeout(resolve, 100));
    return mockConsultationDB.getOrders();
  },

  async getById(id: string): Promise<Order> {
    await new Promise(resolve => setTimeout(resolve, 100));
    const order = mockConsultationDB.getOrder(id);
    if (!order) throw new Error('Order not found');
    return order;
  },

  async getByEncounter(encounterId: string): Promise<Order[]> {
    await new Promise(resolve => setTimeout(resolve, 100));
    return mockConsultationDB.getOrdersByEncounter(encounterId);
  },

  async create(encounterId: string, data: OrderFormData): Promise<Order> {
    await new Promise(resolve => setTimeout(resolve, 200));
    return mockConsultationDB.createOrder({
      ...data,
      encounterId,
      status: 'pending',
    });
  },

  async update(id: string, data: Partial<OrderFormData>): Promise<Order> {
    await new Promise(resolve => setTimeout(resolve, 200));
    const updated = mockConsultationDB.updateOrder(id, data);
    if (!updated) throw new Error('Order not found');
    return updated;
  },

  async updateStatus(id: string, status: 'pending' | 'collected' | 'processing' | 'completed'): Promise<Order> {
    await new Promise(resolve => setTimeout(resolve, 200));
    const updated = mockConsultationDB.updateOrder(id, { status });
    if (!updated) throw new Error('Order not found');
    return updated;
  },

  async linkInvoice(id: string, invoiceId: string): Promise<Order> {
    await new Promise(resolve => setTimeout(resolve, 200));
    const updated = mockConsultationDB.updateOrder(id, { invoiceId });
    if (!updated) throw new Error('Order not found');
    return updated;
  },

  async updateResults(id: string, results: any[]): Promise<Order> {
    await new Promise(resolve => setTimeout(resolve, 200));
    const updated = mockConsultationDB.updateOrder(id, { results });
    if (!updated) throw new Error('Order not found');
    return updated;
  },
};
